import React from 'react';
import TranslateContext from './TranslateContext';

const TranslateHTML = (props) => {
  const { as: Type, value, context, className } = props;
  return (
    <TranslateContext.Consumer>
      {(translate) => (
        <Type
          className={className}
          dangerouslySetInnerHTML={{
            __html: translate(value, context || props),
          }}
        />
      )}
    </TranslateContext.Consumer>
  );
};

TranslateHTML.defaultProps = {
  as: 'span',
};

export default TranslateHTML;
